function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { h } from 'vue';
import defaultAttributes from './defaultAttributes';
/**
 * Converts string to KebabCase
 * Copied from scripts/helper. If anyone knows how to properly import it here
 * then please fix it.
 *
 * @param {string} string
 * @returns {string} A kebabized string
 */

export var toKebabCase = function toKebabCase(string) {
  return string.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};

var createVueComponent = function createVueComponent(iconName, iconNode) {
  return function (props, context) {
    return h('svg', _extends({}, defaultAttributes, {
      width: props.size || defaultAttributes.width,
      height: props.size || defaultAttributes.height,
      "class": ['lucide', "lucide-" + toKebabCase(iconName)]
    }, context.attrs, props), iconNode.map(function (child) {
      return h.apply(void 0, child);
    }));
  };
};

export default createVueComponent;